import { ChannelResolver, ChannelResolveParams } from 'core/repositories/ChannelResolver';
import { DummyChannel } from './Channel';

class DummyChannelResolver implements ChannelResolver {
    async resolve(params: ChannelResolveParams) {
        const cameras = new Map([...params.vehicle.cameras, ...params.vehicle.microphones].map(c => [c.tag, new DummyChannel(c)]));
        const microphones = new Map([...params.vehicle.cameras, ...params.vehicle.microphones].map(c => [c.tag, new DummyChannel(c)]));
        return { cameras, microphones };
    }
}

export { DummyChannelResolver as ChannelResolver };
